/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  InputGroup,
  Modal
} from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  patientRegistrationAction,
  patientEditAction,
  getPatientDetailAction,
  visitListAction,
} from "Front/actions/home";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import { titleOptions, billTypeOptions } from "Front/variables/Variables.jsx";
import { appConstants } from "Front/_constants/app.constants.js";
import { patientListAction, addVisitAction } from "Front/actions/patient";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import loadingImg from "Admin/assets/img/loading.gif";
import MaskedInput from "react-maskedinput";
import {
  taskScreenAction,
  taskScreenHeightWeightRequireForCaloryAction,
} from "Front/actions/taskScreen";
import { emrSetVitalSignsAction } from "Front/actions/emr";
import * as PF from "Front/views/Home/PublicFunction.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "Admin/variables/Variables.jsx";
import Select from "react-select";
import {
  billCategoryListAction,
  billSubCategoryListAction,
  createBillAction,
  updateBillAction,
  billListAction
} from "../../actions/billing";
import BillingTable from "../Pages/BillingModule/BillingTable";
import { debounce, last } from "lodash";
import axios from "axios";
import Print from "../Pages/BillingModule/Print";
import BillingInfo from "./BillingInfo";


let Validator = require("validatorjs");
let formArr = {};
let rules = {
  title: "required",
  first_name: "required|string",
  last_name: "string",
  gender: "required",
  // height: 'required|numeric|min:1',
  // weight: 'required|numeric|min:1',
  // height: 'numeric|min:1',
  // weight: 'numeric|min:1',
  height: "numeric",
  weight: "numeric",
  city: "string",
  //dob: 'required',
  email: "email",
  age: "required|numeric",
  phone:
    localStorage.getItem("is_mobile_no_mandatory") === "yes"
      ? "required|digits_between:10,12"
      : "digits_between:10,12",
};
let mess = {
  required: "This field is required",
};
let validation = [];

let editApi = false;

let isOnline = false;

let cancel;

let lastSearchedText = ""



class PatientRegistration extends Component {
  constructor(props) {
    super(props);
    console.log(props, "-----props-------")
    this.state = {
      formArr: [],
      patientInfo: this.props.patientData,
      patient_idError: null,
      titleError: null,
      first_nameError: null,
      last_nameError: null,
      genderError: "",
      dobError: null,
      ageError: null,
      emailError: null,
      heightError: null,
      weightError: null,
      cityError: null,
      remarkError: null,
      econsultationError: null,
      alert: null,
      isConsultationDisabled: this?.props?.parentComponent === "billing" ? true : false,
      formData: {
        patientClinicId: this.props.patientData
          ? this.props.patientData.patientId
          : "",
        patientId: this.props.patientData ? this.props.patientData._id : "",
        visitId: this.props.patientData
          ? this.props.patientData.emrVisitId
          : "",
        patientEditId: this.props.patientData ? this.props.patientData._id : "",
        title: this.props.patientData ? this.props.patientData.title : "",
        first_name: this.props.patientData
          ? this.props.patientData.firstName
          : "",
        last_name: this.props.patientData
          ? this.props.patientData.lastName
          : "",
        gender: this.props.patientData ? this.props.patientData.gender : "",
        phone: this.props.patientData ? this.props.patientData.phone : "",
        dob:
          this.props.vitalSignsData && this.props.vitalSignsData.dob
            ? moment(this.props.vitalSignsData.dob).format("YYYY-MM-DD")
            : this.props.patientData && this.props.patientData.dob
              ? moment(this.props.patientData.dob).format("YYYY-MM-DD")
              : "",
        is_dob: this.props.patientData ? this.props.patientData.is_dob : false,
        age:
          (this.props.parentComponent == "headerlinks")
            ? ""
            : this.props.vitalSignsData.patientId === this.props.patientData._id
              ? this.props.vitalSignsData.age
                ? this.props.vitalSignsData.age
                : this.props.patientData.age
                  ? this.props.patientData.age
                  : ""
              : this.props.patientData.age
                ? this.props.patientData.age
                : "",
        email: this.props.patientData ? this.props.patientData.email : "",
        height:
          (this.props.parentComponent == "headerlinks")
            ? ""
            : this.props.vitalSignsData.patientId === this.props.patientData._id
              ? this.props.vitalSignsData
                ? this.props.vitalSignsData.height
                : this.props.patientData
                  ? this.props.patientData.height
                  : ""
              : this.props.patientData
                ? this.props.patientData.height
                : "",
        weight:
          (this.props.parentComponent == "headerlinks")
            ? ""
            : this.props.vitalSignsData.patientId === this.props.patientData._id
              ? this.props.vitalSignsData
                ? this.props.vitalSignsData.weight
                : this.props.patientData
                  ? this.props.patientData.weight
                  : ""
              : this.props.patientData
                ? this.props.patientData.weight
                : "",
        city: this.props.patientData ? this.props.patientData.city : "",
        remark: this.props.patientData ? this.props.patientData.remark : "",
        dobd:
          this.props.patientData && this.props.patientData.dob
            ? new Date(this.props.patientData.dob)
            : "",
        age_color: "",
        econsultation:
          this.props.patientData && this.props.patientData.econsultation
            ? true
            : false,
        appointmentId:
          this.props.patientData && this.props.patientData.appointmentId
            ? this.props.patientData.appointmentId
            : "",
        toggleConsultation: this.props.patientData && this.props.patientData.econsultation
          ? true
          : false
      },
      showProcessing: false,
      search_date: this.props.search_date,
      patientClinicIdError: "",
      phoneError: "",
      datepickeropen: false,
      isOpdConsultation: false,
      isOnlineConsultation: false,
      lengthWeight: false,
      lengthHeight: false,
      billType: "",
      billCategory: {},
      billCategoryOptions: [],
      billSubCategory: {},
      billSubCategoryOptions: [],
      services: [],
      totalAmount: 0,
      totalPaidAmount: 0,
      totalDiscountAmount: 0,
      totalRemainingAmount: 0,
      paymentMode: "Cash",
      patients: [],
      selectedPatient: null,
      showPreviewModal: false,
      patientPrintDetails: null,
      patientDetail: this.props?.patientData ? this.props?.patientData : null,
      mode: this.props?.patientData?.patientId ? "edit"
        : "new",
      isCreateVisit: this.props.showRegBillView ? true : false,// this flag is used for creating visit in case of updating old patient from reg+bill modal
      defaultConsultationServices: [],
      totalPaidAmountError: "",
      serviceErrorMsg: null,
      hasUserEditedPaidAmount: false,
      latestBill: null,
      billSubCategoryList: [],
      billOptions: [],
      totalRefundAmount: 0,
      isBillingDisabled: false,
      createdAt: this.props?.patientData ? this.props?.patientData?.createdAt : null,
    };

    validation = new Validator(this.state, rules, mess);
    validation.passes();
    validation.fails();

    this.handleDob = this.handleDob.bind(this);

    if (this.props.patientData) {
      //this.handleDob(this.props.patientData.dob, 1);
    }

    this.getPatientList = this.getPatientList.bind(this);
    this.dateChanged = this.dateChanged.bind(this);
    this.datepickeropenClickFun = this.datepickeropenClickFun.bind(this);
    isOnline = false;
    this.getBillCategoryList = this.getBillCategoryList.bind(this);
    this.handleBillCategory = this.handleBillCategory.bind(this);
    this.createBill = this.createBill.bind(this);
    this.cleanUp = this.cleanUp.bind(this)
    this.patientSearch = this.patientSearch.bind(this)
    this.handlePatientDetails = this.handlePatientDetails.bind(this)
    this.fillPatientDetails = this.fillPatientDetails.bind(this)
    this.setShowPreviewModal = this.setShowPreviewModal.bind(this)
    this.patientRegistration = this.patientRegistration.bind(this)
    this.handleBillingType = this.handleBillingType.bind(this)
    this.updateBill = this.updateBill.bind(this)
    this.getBillList = this.getBillList.bind(this)
    this.getBillingType = this.getBillingType.bind(this)
    this.handleBill = this.handleBill.bind(this)
    this.isSaveButtonClicked = false
    this.isSaveExitClicked = false;
    this.isPageLoad = true;
    this.handleFillOldPatientLatestBillDetails = this.handleFillOldPatientLatestBillDetails.bind(this);
    this.handleTotalPaidAmount = this.handleTotalPaidAmount.bind(this)
    this.handleUpdateServicesOnConsultationChange = this.handleUpdateServicesOnConsultationChange.bind(this)
    this.handleBillChange = this.handleBillChange.bind(this)
    this.clearBillDetails = this.clearBillDetails.bind(this)
    this.handlePaymentMode = this.handlePaymentMode.bind(this)
    this.handleResetState = this.handleResetState.bind(this)
    this.handleRedirect = this.handleRedirect.bind(this)
    this.handleRemoveErrorMsgForAlreadyExist = this.handleRemoveErrorMsgForAlreadyExist.bind(this)
  }

  componentDidMount() {
    let tempFormData = JSON.stringify(this.state.formData)
    // let billType = "Paid"
    // if (this.props?.patientData && this.props?.patientData?._id) {
    //   let lastVisitDate = null;
    //   if (this.props?.patientData?.visitCountData && this.props?.patientData?.visitCountData.length > 0) {
    //     lastVisitDate = this.props?.patientData?.visitCountData[0]?.lastVisitDate;
    //   }
    //   const patientData = {
    //     addVisit: this.props?.patientData?.addVisit,
    //     lastVisitDate: lastVisitDate,
    //     createdAt: this.props?.patientData?.createdAt,
    //   }
    //   billType = this.getBillingType(patientData)
    // }
    // this.setState({ billType: billType })
    if (this.props.patientData && this.props.patientData.econsultation)
      isOnline = this.props.patientData.econsultation ? true : false
    let fields = JSON.parse(tempFormData)
    if (fields.dob) {
      fields.age = PF.getAgeByDob(fields.dob)
    } else {
      fields.is_dob = false;
      fields.age_color = "red";
      let dob = moment().subtract("years", fields.age);

      fields.dob = moment(dob._d).format("YYYY-MM-DD");
      fields.dobd = dob._d;
      //field['dobd'] = "";
      let dobDisable = false;
      if (fields.age > 0) {
        dobDisable = true;
      }

      this.setState({
        formData: fields,
        dobDisable: dobDisable,
        ageDisable: false,
      });
    }

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.props.patientData && this.props.patientData.econsultation
      ? this.setState({ isOnlineConsultation: true, isOpdConsultation: false })
      : this.setState({ isOpdConsultation: true, isOnlineConsultation: false });

    let tempRules = rules;
    tempRules.phone =
      localStorage.getItem("is_mobile_no_mandatory") === "yes"
        ? "required|digits_between:10,12"
        : "digits_between:10,12";
    rules = tempRules;
    // if (this.props?.parentComponent === "dropDownSearch") {
    //   let lastVisitDate = null;
    //   if (this.props?.patientData?.visitCountData && this.props?.patientData?.visitCountData.length > 0) {
    //     lastVisitDate = this.props?.patientData?.visitCountData[0]?.lastVisitDate;
    //   }
    //   const patientData = {
    //     addVisit: this.props?.patientData.addVisit,
    //     lastVisitDate: lastVisitDate,
    //     createdAt: this.props?.patientData?.createdAt,
    //   }
    //   this.handleBillingType(patientData);
    //   billType = this.getBillingType(patientData)
    // }
    // if (this.props.appointmentData && this.props.appointmentData.appointmentId) {
    //   let lastVisitDate = null;
    //   if (this.props?.appointmentData?.visitCountData && this.props?.appointmentData?.visitCountData.length > 0) {
    //     lastVisitDate = this.props?.appointmentData?.visitCountData[0]?.lastVisitDate;
    //   }
    //   const patientData = {
    //     addVisit: this.props?.appointmentData.addVisit,
    //     lastVisitDate: lastVisitDate,
    //     createdAt: this.props?.appointmentData?.visitCountData[0]?.createdAt,
    //   }
    //   this.handleBillingType(patientData);
    // }

    // if (this.props.billCategoryList.length === 0)
    //   this.getBillCategoryList()
    // else {
    //   if (this.props?.patientData && this.props?.patientData?._id)
    //     this.getBillList()
    //   else this.fillDefaultConsultation(billType)
    // }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isBillCreated !== this.props.isBillCreated && nextProps.isBillCreated) {
      let tempData = this.state.formData
      // tempData.patientClinicId = "A11001096"
      let tempPatientDetails = {}
      tempPatientDetails.firstName = this.state.formData.first_name
      tempPatientDetails.lastName = this.state.formData.last_name
      tempPatientDetails.patientClinicId = tempData.patientClinicId
      this.setState({ formData: tempData, patientDetail: tempPatientDetails, latestBill: nextProps?.billCreated?.data })
      // const msg = `Patient ${this.state.formData.patientClinicId ? "updated" : "registered"} and bill created successfully`
      this.successAlert("Bill Created Successfully");
      this.handleRedirect()
    }

    // if (nextProps.latestBill && nextProps.latestBill.isCancelled == this.props.latestBill?.isCancelled) {
    //   this.setState({ isBillingDisabled: nextProps.latestBill.isCancelled });
    // }

    if (nextProps?.isAddVisit !== this.props.isAddVisit && nextProps?.isAddVisit) {
      this.handleRedirect()
    }

    if (nextProps.isPatientDetail !== this.props.isPatientDetail) {
      if (nextProps.PatientDetail && nextProps.PatientDetail.data) {
        let formData = this.state.formData;
        formData["patientId"] = nextProps.PatientDetail.data._id;
        formData["patientClinicId"] =
          nextProps.PatientDetail.data.patientClinicId;
        // formData['patientEditId'] = nextProps.PatientDetail.data.pId;
        formData["title"] = nextProps.PatientDetail.data.title;
        formData["first_name"] = nextProps.PatientDetail.data.firstName;
        formData["last_name"] = nextProps.PatientDetail.data.lastName;
        formData["gender"] = nextProps.PatientDetail.data.gender;
        formData["phone"] = nextProps.PatientDetail.data.phone;
        formData["dob"] = moment(nextProps.PatientDetail.data.dob).format(
          "YYYY-MM-DD"
        );
        formData["email"] = nextProps.PatientDetail.data.email;
        formData["height"] = nextProps.PatientDetail.data.height;
        formData["weight"] = nextProps.PatientDetail.data.weight;
        formData["city"] = nextProps.PatientDetail.data.city;
        formData["remark"] = nextProps.PatientDetail.data.remark;
        //formData['dobd'] = moment(nextProps.PatientDetail.data.dob).format('MM/DD/YYYY');
        formData["dobd"] = new Date(nextProps.PatientDetail.data.dob);
        formData["age"] = nextProps.PatientDetail.data.age;
        formData["econsultation"] = nextProps.PatientDetail.data.econsultation;
        this.setState({ formData: formData });
        this.setState({ patientClinicIdError: "" });
      }
    }

    if (nextProps.isPatientDetailError !== this.props.isPatientDetailError) {
      this.setState({ patientClinicIdError: "Patient not found for this id." });
      this.setState({
        formData: {
          patientId: "",
          patientClinicId: "",
          patientEditId: "",
          title: "",
          first_name: "",
          last_name: "",
          gender: "",
          dob: "",
          age: "",
          email: "",
          height: "",
          weight: "",
          city: "",
          remark: "",
          dobd: "",
          phone: "",
          econsultation: false,
        },
      });
    } else {
      this.setState({ patientClinicIdError: "" });
    }

    if (nextProps.isPatientEdit !== this.props.isPatientEdit && editApi) {

      if (this.props.showRegBillView) {
        if (this.state.latestBill)
          this.updateBill()
        else {
          if (this.state.services && this.state.services.length > 0)
            this.createBill(this.state.formData.patientId)
          else {
            this.successAlert("Patient Successfully Updated");
          }
        }
      }


      if (this.props.patientUpdate != undefined) {
        let patientUpdateData = this.state.formData;
        if (this.props.appointmentData != undefined) {
          patientUpdateData.appointmentId =
            this.props.appointmentData.appointmentId;
        }

        this.props.patientUpdate(JSON.parse(JSON.stringify(patientUpdateData)));
      }

      // if(this.props && this.props.location && this.props.location.state && this.props.location.state.pagination){
      //     this.getPatientList(this.props.location.state.pagination)
      // }

      editApi = false;
      this.setState({ showProcessing: false });
      // setTimeout(function () {
      //   let params = {
      //     clinicId: localStorage.getItem("clinicId"),
      //   };
      //   appConstants.socket.emit("addPatient", params);
      // }, 1000);

      let formData = JSON.parse(JSON.stringify(this.state.formData));

      //this.getPatientList()
      if (this.props.parent === "history") {
        let taskData = this.state.patientInfo;
        taskData.title = formData.title;
        taskData.firstName = formData.first_name
          ? formData.first_name
          : taskData.firstName;
        taskData.lastName = formData.last_name ? formData.last_name : "";
        taskData.gender = formData.gender;
        taskData.dob = formData.dob ? formData.dob : taskData.dob;
        taskData.age = formData.age ? formData.age : taskData.age;
        taskData.height = formData.height ? formData.height : 0.0;
        taskData.weight = formData.weight ? formData.weight : 0.0;
        taskData.city = formData.city ? formData.city : "";
        taskData.remark = formData.remark ? formData.remark : taskData.remark;
        taskData.phone = formData.phone ? formData.phone : "";

        taskData.econsultation = this.state.isOnlineConsultation ? true : false;
        // console.log(isOnline,this.state.isOnlineConsultation, this.props.parent,formData,taskData,"111111")
        let bmi = 0.0;
        let c1 = 0.0;
        let c2 = 0.0;
        let c3 = 0.0;
        let calorie = 0;
        taskData.calorieHieghtWeightFilledOnEdit = true; //this Variable Is Maintained For Filling Calorie Value In Drop Down If Height,Weight Not Filled At The Time Of Patinet Registeraation.
        if (formData.height != "" && formData.weight != "") {
          let h = formData.height ? formData.height : taskData.height;
          let w = formData.weight ? formData.weight : taskData.weight;
          let g = formData.gender;
          let height_in_m = h / 100;
          if (height_in_m > 0 && w > 0) {
            bmi = w / (height_in_m * height_in_m);
            bmi = bmi.toFixed(2);
            c1 = PF.getMaintainWeight(h, w, g);
            c2 = PF.getLooseWeight(h, w, g);
            c3 = PF.getGainWeight(h, w, g);
            calorie = PF.getCalorie(h, w, g);
            taskData.segCalorie = calorie;
          }
        } else {
          taskData.segCalorie = 0;
        }
        taskData.c1 = c1;
        taskData.c2 = c2;
        taskData.c3 = c3;
        taskData.bmi = bmi;
        this.props.taskScreenAction(taskData);
        let vitalSignData = this.props.vitalSignsData;
        vitalSignData.patientId = formData.patientId;
        vitalSignData.patientName =
          formData.first_name + " " + formData.last_name;
        vitalSignData.age = formData.age;
        vitalSignData.height = formData.height ? formData.height : 0.0;
        vitalSignData.weight = formData.weight ? formData.weight : 0.0;
        vitalSignData.gender = formData.gender;
        vitalSignData.bmi = bmi;
        vitalSignData.temperature =
          this.props.vitalSignsData?.temperature != undefined
            ? this.props.vitalSignsData.temperature
            : "";
        vitalSignData.bp =
          this.props.vitalSignsData?.bp != undefined
            ? this.props.vitalSignsData.bp
            : "";
        vitalSignData.pulse =
          this.props.vitalSignsData?.pulse != undefined
            ? this.props.vitalSignsData.pulse
            : "";
        vitalSignData.diabetesDuration =
          this.props.vitalSignsData?.diabetesDuration != undefined
            ? this.props.vitalSignsData.diabetesDuration
            : "";
        vitalSignData.toggleDuration =
          this.props.vitalSignsData?.toggleDuration != undefined
            ? this.props.vitalSignsData.toggleDuration
            : false;
        this.props.emrSetVitalSignsAction(vitalSignData);
        this.props.taskScreenHeightWeightRequireForCaloryAction(false);
        if (this.props.getCalorieList !== undefined)
          this.props.getCalorieList();
        //this.onDismiss()
      }
      if (!this.props.showRegBillView) {
        let formArr = [];
        formData["patientId"] = "";
        formData["patientEditId"] = "";
        formData["patientClinicId"] = "";
        formData["title"] = "";
        formData["first_name"] = "";
        formData["last_name"] = "";
        formData["gender"] = "";
        formData["dob"] = "";
        formData["age"] = "";
        formData["email"] = "";
        formData["height"] = "";
        formData["weight"] = "";
        formData["city"] = "";
        formData["remark"] = "";
        formData["dobd"] = "";
        formData["phone"] = "";
        formData["econsultation"] = false;
        this.setState({ formData: formData, patientClinicIdError: "", formArr });
        if (nextProps?.PatientEditMessage?.isRedirect) {
          if (nextProps?.PatientEditMessage?.isRedirect)
            this.props.history.push(`/dashboard`);
        }
        this.props.onDismiss();
      }
      if (this.props.showRegBillView && this.state.services.length === 0 && this.isSaveExitClicked) {
        this.cleanUp();
        this.isSaveExitClicked = false
      }


      if (this.props.showRegBillView && this.state.services.length === 0 && this.isSaveButtonClicked) {
        //this.successAlert("Patient Successfully Updated");
        this.isSaveButtonClicked = false;
      }


    }

    if (
      nextProps.isPatientRegistration !== this.props.isPatientRegistration &&
      editApi && nextProps.isPatientRegistration
    ) {
      let tempData = this.state.formData
      tempData.patientClinicId = nextProps?.PatientRegistrationMessage?.patientClinicId
      tempData.patientId = nextProps?.PatientRegistrationMessage?.patientId
      editApi = false;
      this.setState({ showProcessing: false, formData: tempData });
      setTimeout(function () {
        let params = {
          clinicId: localStorage.getItem("clinicId"),
        };
        appConstants.socket.emit("addPatient", params);
      }, 1000);

      if (this.state.services && this.state.services.length > 0)
        this.createBill(nextProps?.PatientRegistrationMessage?.patientId)
      else this.cleanUp()

    }

    if (nextProps.isBillUpdated !== this.props.isBillUpdated && nextProps.isBillUpdated) {
      this.successAlert("Bill Updated Successfully");
      let url = "/";
      if (this.props.history?.location?.pathname === "/") url = "/dashboard";
      else if (this.props.history?.location?.pathname === "/dashboard") url = "/";
      if (this.props.history?.location?.pathname === "/patient-search" && this.isSaveExitClicked) url = "/";
      if (this.isSaveExitClicked) {
        this.props.history.push({ pathname: url, econsultation: isOnline });
        const msg = `Patient ${this.state.mode === "edit" ? "updated" : "registered"} and bill created successfully`
        this.props.onDismiss(msg);
      }
    }
  }

  dateChanged(d) {
    this.setState({ date1: d });
  }

  getBillList() {
    this.props.billListAction({
      "limit": 1000,
      "offset": 0,
      "order": "createdAt",
      "direction": "desc",
      "search": "",
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      patientId: this.props.patientData ? this.props.patientData._id : "",
    })
  }

  getPatientList() {
    let data = {};
    data["patient_id"] = "";
    data["city"] = "";
    data["first_name"] = "";
    data["last_name"] = "";
    data["direction"] = "desc";
    data["order"] = "createdAt";
    data["offset"] = 0;
    data["limit"] = 10;
    this.props.patientListAction(data);
  }

  getBillCategoryList() {
    this.props.billCategoryListAction();
  }

  successAlert(msg, link) {
    // this.setState({
    //     alert: (
    //         <SweetAlert
    //             success
    //             style={{ display: "block", marginTop: "-100px" }}
    //             title="Success"
    //             onConfirm={() => this.hideAlert()}
    //             //onCancel={() => this.hideAlert()}
    //             confirmBtnBsStyle="info"
    //         >
    //             {msg}
    //         </SweetAlert>
    //     )
    // });

    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className="pe-7s-check"
          style={{
            fontSize: "30px",
            color: "#fff",
            padding: "0px !important",
            top: "0% !important",
          }}
        ></span>
      ),
      message: (
        <div>
          {/* <p>{from}</p> */}
          <span>{msg}</span>
        </div>
      ),
      level: "success",
      position: "tr",
      autoDismiss: 2,
    });

  }

  hideAlert() {
    this.props.onDismiss();
    this.setState({
      alert: false,
    });
  }

  handleChange(e) {
    let { billType, formData, services, defaultConsultationServices, billCategoryOptions } = this.state;
    formData[e.target.name] =
      e.target.type === "radio" ? !formData[e.target.name] : e.target.value;

    if (e.target.name === "age") {
      // var today = new Date();
      formData["dob"] = moment().subtract(e.target.value, "years"); //(today.getFullYear()-e.target.value) + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    }

    if (e.target.name === "phone") {
      if (e.target.value && e.target.value.length != 10) {
        //this.setState({ phoneError: (<small className="text-danger">Phone number has to be 10 digits.</small>) })
      } else {
        //this.setState({ phoneError: null })
      }
    }

    if (
      e.target.name === "first_name" ||
      e.target.name === "last_name" ||
      e.target.name === "city"
    ) {
      formData[e.target.name] = e.target.value.toUpperCase();
    }

    if (e.target.name === "econsultation") {
      isOnline = e.target.value === "true"; // Set the value of isOnline based on the input
      formData[e.target.name] = isOnline ? true : false;
      formData["toggleConsultation"] = !this.state?.formData?.toggleConsultation
    }

    if (e.target.name === "weight") {
      if (e.target.value.length < 7) {
        this.setState({ e, weightError: (<small className="text-danger">Maximum 5 Character Allowed</small>) })
      } else {
        this.setState({ weightError: null })
      }
    }

    if (e.target.name === "height") {
      if (e.target.value.length < 4) {
        this.setState({ heightError: (<small className="text-danger">Maximum 3 Character Allowed</small>) })
      } else {
        this.setState({ heightError: null })
      }
    }
    this.setState({ ...formData });
  }

  onPatientId(e) {
    e.preventDefault();
    let formData = this.state.formData;

    this.props.getPatientDetailAction({
      id: formData.patientClinicId,
      clinic_id: localStorage.getItem("clinicId"),
    });
  }

  onClear(e) {
    e.preventDefault();

    this.setState({
      formData: {
        patientId: "",
        patientClinicId: "",
        patientEditId: "",
        title: "",
        first_name: "",
        last_name: "",
        gender: "",
        dob: "",
        age: "",
        email: "",
        height: "",
        weight: "",
        city: "",
        remark: "",
        dobd: "",
        phone: "",
        econsultation: false,
      },
    });
  }

  handleDob(date, type = 2) {
    var selectedDate = moment(date);
    //var today = moment();
    let day = moment().diff(selectedDate, "day");

    let field = this.state.formData;
    field["age_color"] = "green";
    if (day <= 0) {
      this.setState({ formData: field });
      this.setState({ dobError: "Invalid Date." });
    } else {
      field["dob"] = moment(date).format("YYYY-MM-DD");
      field["dobd"] = new Date(date);

      let a = moment(date);
      let b = moment();

      let year = b.diff(a, "years");

      let month = b.diff(a, "month") % 12;

      var dateDiff = year;

      if (year == 0) {
        //dateDiff = year+'.'+month;
      }

      //let dateDiff = new Date().getFullYear() - new Date(date).getFullYear();

      field["age"] = dateDiff;

      if (type != 1) {
        field["is_dob"] = true;
        let ageDisable = true;
        this.setState({
          formData: field,
          dobError: "",
          ageDisable: ageDisable,
          dobDisable: false,
        });
      } else {
        this.setState({ formData: field, dobError: "" });
      }
    }
  }

  handleAge(e) {
    e.preventDefault();
    let field = this.state.formData;
    field["age"] = e.target.value;
    field["is_dob"] = false;
    field["age_color"] = "red";
    let dob = moment().subtract("years", e.target.value);

    field["dob"] = moment(dob._d).format("YYYY-MM-DD");
    field["dobd"] = dob._d;
    //field['dobd'] = "";
    let dobDisable = false;
    if (e.target.value.length > 0) {
      dobDisable = true;
    }

    this.setState({
      formData: field,
      dobDisable: dobDisable,
      ageDisable: false,
    });
  }

  allValidate(check) {
    if (!check) {
      formArr = [];
      Object.keys(rules).forEach(function (key) {
        formArr[key] = "TT";
      });
      this.setState({
        formArr,
      });
    }
    if (validation.passes()) {
      if (
        this.state.formData["dob"] === "" &&
        this.state.formData["age"] === ""
      ) {
        this.setState({ dobError: "The dob or age is required" });
      } else {
        return 1;
      }
    }
  }

  patientRegistration(evt) {
    this.setState({ showProcessing: true });
    evt.preventDefault();
    let formData = this.state.formData;
    formData["patient_id"] = formData.patientId;
    // formData['patientId'] = formData.patientId;
    if (this.state.totalAmount > 0) {
      if (this.state.totalPaidAmount > this.state.totalAmount) {
        this.setState({ totalPaidAmountError: "Paid amount cannot be greater than total amount" })
        return;
      } else {
        this.setState({ totalPaidAmountError: "" })
      }
    }
    if (this.allValidate(false)) {
      if (
        this.state.formData.patientId &&
        this.state.formData.patientId !== ""
      ) {
        this.props.patientEditAction(this.state);
      } else {
        this.props.patientRegistrationAction(this.state);
      }
      editApi = true;
    } else this.setState({ showProcessing: false });

    //return validation.errors()
  }

  validDate(current) {
    var yesterday = moment().toDate();
    return current.isBefore(yesterday);
  }

  datepickeropenClickFun() {
    this.setState({ datepickeropen: true });
  }

  handleBillCategory(category) {
    this.setState({ billCategory: category, billSubCategory: {} })
    if (this.props?.billSubCategoryList?.length > 0) {
      const filteredSubcategories = this.props?.billSubCategoryList?.data?.filter((subCat) => subCat?.categoryId?._id === category?._id)
      const billSubCategoryOptions = filteredSubcategories.map((ele) => {
        return {
          label: ele?.name, value: ele?._id, ...ele
        }
      })
      this.setState({ billSubCategoryOptions: billSubCategoryOptions })
    } else {
      this.props.billSubCategoryListAction(category.value)
    }
  }

  handleBillingDisabledChange = (value) => {
    this.setState({ isBillingDisabled: value });
  };

  addServiceToBill = (billSubCategory, checkForAlreadyAdded = false) => {
    const { services } = this.state;
    if (!billSubCategory || !billSubCategory.label) return;

    if (checkForAlreadyAdded) {
      const isDuplicate = services.some(service => service.serviceId === billSubCategory.value);
      if (isDuplicate) {
        let errorObj = { id: billSubCategory.value, msg: `${billSubCategory.label} is already added to the bill list` }
        this.setState({ serviceErrorMsg: errorObj })
        return;
      }
      const isSystemDefaultNew = billSubCategory.systemDefault;
      const existingSystemDefaultService = services.find(service => service.systemDefault);
      console.log(existingSystemDefaultService, '-----existingSystemDefaultService')
      if (isSystemDefaultNew && existingSystemDefaultService) {
        let errorObj = { id: existingSystemDefaultService._id, msg: `${existingSystemDefaultService.item} is already added to the bill list` }
        this.setState({ serviceErrorMsg: errorObj })
        return;
      }
    }

    const newItem = {
      id: Date.now(),
      serviceId: billSubCategory?.value,
      item: billSubCategory.label,
      price: billSubCategory.price,
      quantity: 1,
      discount: 0,
      ...billSubCategory
    };

    this.setState(prev => ({
      services: checkForAlreadyAdded ? [...prev.services, newItem] : [newItem],
      serviceErrorMsg: null
    }));
  };


  handleBillingChange = (id, field, value) => {
    const services = this.state.services.map(item => {
      if (item.id === id) {
        return {
          ...item,
          [field]: value === "" ? "" : parseFloat(value)
        };
      }
      return item;
    });
    this.setState({ services });
  };

  handleBillingDelete = (id) => {
    const services = this.state.services.filter(item => item.id !== id);
    this.setState({ services });
  };

  createBill = (patientId) => {
    const payload = {
      patientId: patientId,
      totalAmount: this.state.totalAmount,
      totalPaidAmount: this.state.totalPaidAmount,
      totalDiscountAmount: this.state.totalDiscountAmount,
      totalRemainingAmount: this.state.totalRemainingAmount,
      services: this.state.services,
      paymentMode: this.state.paymentMode,
      installmentAmount: this.state.totalPaidAmount
    }
    this.props.createBillAction(payload)
  }

  updateBill = () => {
    const payload = {
      id: this.state.latestBill._id,
      totalAmount: this.state.totalAmount,
      totalPaidAmount: this.state.totalPaidAmount,
      totalDiscountAmount: this.state.totalDiscountAmount,
      totalRemainingAmount: this.state.totalRemainingAmount,
      services: this.state.services,
      paymentMode: this.state.paymentMode,
      installmentAmount: this.state.totalPaidAmount
    }
    this.props.updateBillAction(payload)
  }

  cleanUp = () => {
    let formData = this.state.formData;
    let formArr = [];
    formData["patientId"] = "";
    formData["patientEditId"] = "";
    formData["patientClinicId"] = "";
    formData["title"] = "";
    formData["first_name"] = "";
    formData["last_name"] = "";
    formData["gender"] = "";
    formData["dob"] = "";
    formData["age"] = "";
    formData["email"] = "";
    formData["height"] = "";
    formData["weight"] = "";
    formData["city"] = "";
    formData["remark"] = "";
    formData["dobd"] = "";
    formData["phone"] = "";
    formData["econsultation"] = false;
    this.setState({ formData: formData, patientClinicIdError: "", formArr });
    const msg = `Patient ${this.state.mode === "edit" ? "updated" : "registered"} and bill created successfully`
    if ((this.state.services && this.state.services.length === 0) || this.isSaveExitClicked) {
      let url = "/";
      if (this.props.history?.location?.pathname === "/") url = "/dashboard";
      else if (this.props.history?.location?.pathname === "/dashboard") url = "/";
      console.log(url, this.props.history?.location?.pathname, this.isSaveExitClicked, "*************")
      if (this.props.history?.location?.pathname === "/patient-search" && this.isSaveExitClicked) url = "/";
      if (this.isSaveExitClicked) {
        this.props.history.push({ pathname: url, econsultation: isOnline });
        const msg = `Patient ${this.state.mode === "edit" ? "updated" : "registered"} and bill created successfully`
      }
    }
    this.props.onDismiss(msg);

  }

  patientSearch = debounce(async (inputValue) => {
    if (cancel) {
      cancel(); // Cancel the previous API request
    }

    // setIsSpecialCharacter(false);

    let search = inputValue.trim();
    lastSearchedText = search; // Store the last searched text

    let sessionToken = localStorage.getItem("token");

    if (search !== "") {
      let strUrl = appConstants.paAppURL + "patient-search";

      try {
        const response = await axios.get(strUrl, {
          params: { search: search },
          cancelToken: new axios.CancelToken((c) => (cancel = c)), // Assign cancel function
          headers: {
            Authorization: sessionToken,
            "Content-Type": "application/json",
          },
        });

        if (search === lastSearchedText) {
          const formattedOptions = response.data.data.map((item) => ({
            value: item?._id,
            label: `${item.firstName} 
            ${item.lastName} 
            (${item.patientClinicId} , 
            Age:${PF.getAgeByDob(item.dob)} Y 
            ${item.phone ? `, Phone:${item.phone}` : ''} 
            ${item.city ? `, ${item.city}` : ''} 
            ${item.height ? `, ${item.height} CM` : ''} 
            ${item.weight ? `, ${item.weight} KG` : ''})`,
            ...item
          }));
          this.setState({ patients: formattedOptions })
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log("Previous request canceled", error.message);
        } else {
          console.error("API Error:", error);
        }
      }
    } else {
      this.setState({ patients: [] })
    }
  }, 300);

  handlePatientDetails = (searchedPatient) => {
    this.fillPatientDetails(searchedPatient);
  }

  fillPatientDetails = (searchedPatient) => {
    console.log(searchedPatient, "fillPatientDetails")
    const formDataDetails = {
      patientClinicId: searchedPatient ? searchedPatient?.patientClinicId : "",
      patientId: searchedPatient ? searchedPatient?._id : "",
      visitId: "",
      patientEditId: searchedPatient ? searchedPatient?._id : "",
      title: searchedPatient ? searchedPatient?.title : "",
      first_name: searchedPatient ? searchedPatient?.firstName : "",
      last_name: searchedPatient ? searchedPatient?.lastName : "",
      age: searchedPatient ? searchedPatient?.age : "",
      phone: searchedPatient ? searchedPatient?.phone : "",
      gender: searchedPatient ? searchedPatient?.gender : "",
      dob: searchedPatient ? searchedPatient?.dob ? moment(searchedPatient?.dob).format("YYYY-MM-DD") : "" : "",
      is_dob: searchedPatient?.is_dob || false,
      email: searchedPatient ? searchedPatient?.email : "",
      height: searchedPatient ? searchedPatient?.height : "",
      weight: searchedPatient ? searchedPatient?.weight : "",
      city: searchedPatient ? searchedPatient?.city : "",
      remark: searchedPatient ? searchedPatient?.remark : "",
      dobd: searchedPatient ? searchedPatient?.dob ? new Date(searchedPatient?.dob) : "" : "",
      age_color: "",
      econsultation: searchedPatient ? searchedPatient?.econsultation : false,
      appointmentId: "",
      toggleConsultation: this.state?.formData?.toggleConsultation
    }
    this.setState({
      formData: formDataDetails,
      selectedPatient: searchedPatient,
      mode: "edit",
      isOnlineConsultation: searchedPatient?.econsultation,
      isOpdConsultation: !searchedPatient?.econsultation ? true : false,
      createdAt: searchedPatient?.createdAt,

    })

    this.setState(prevState => ({
      formData: formDataDetails,
      selectedPatient: searchedPatient,
      mode: "edit",
      isOnlineConsultation: searchedPatient?.econsultation,
      isOpdConsultation: !searchedPatient?.econsultation ? true : false,
      createdAt: searchedPatient?.createdAt,

    }));
  }


  setShowPreviewModal = (value) => {
    this.setState({ showPreviewModal: value })
  }

  getBillingType = (selectedPatient) => {
    let billType = "";
    const { defaultConsultationServices, services, billCategory, billCategoryOptions } = this.state
    let updatedServices = services.filter((service) => !service?.systemDefault);
    if (selectedPatient) {
      const { lastVisitDate, createdAt } = selectedPatient;
      let lastVisitDateToUse = createdAt;

      // Agar lastVisitDate hai to use karein, nahi to createdAt
      if (lastVisitDate) lastVisitDateToUse = lastVisitDate;
      lastVisitDateToUse = moment(lastVisitDateToUse).format("YYYY-MM-DD");

      let date1 = new Date(lastVisitDateToUse);
      let date2 = new Date();
      let billingCycle = localStorage.getItem("billingCycle");

      // Agar billing cycle local storage se mile to use karein
      if (billingCycle) {
        billingCycle = JSON.parse(billingCycle);
      }

      // Billing cycle ko add karen
      date1.setDate(date1.getDate() + billingCycle);

      // Moment ko use karke date ko format karna
      date1 = moment(date1).format("YYYY-MM-DD");
      date2 = moment(date2).format("YYYY-MM-DD");

      let billType = "Paid";  // Default to Paid

      // Agar lastVisitDateToUse null hai to Paid
      if (lastVisitDateToUse == null) {
        billType = "Paid";
      } else if (lastVisitDateToUse === date2) {
        // Agar aaj ki date hai to Paid
        billType = "Paid";
      } else if (new Date(date1) > new Date(date2)) {
        // Agar date1 (last visit + billing cycle) aaj se bada hai to Free
        billType = "Free";
      } else {
        // Agar date1 (last visit + billing cycle) aaj se chhota hai to Paid
        billType = "Paid";
      }

      return billType;
    }

  }

  handleBillingType = (selectedPatient) => {
    let billType = "";
    const billCategoryOptions = this.props?.billCategoryList?.data.map((ele) => {
      return {
        label: ele?.name, value: ele?._id, ...ele
      }
    })
    const defaultCategory = billCategoryOptions.find(ele => ele?.systemDefault)
    const filteredSubcategories = this.props?.billSubCategoryList?.data?.filter((subCat) => subCat?.categoryId?._id === defaultCategory?._id)
    const billSubCategoryOptions = filteredSubcategories.map((ele) => {
      return {
        label: ele?.name, value: ele?._id, ...ele
      }
    })
    this.setState({ billCategoryOptions: billCategoryOptions, billSubCategoryOptions: billSubCategoryOptions })
    if (selectedPatient) {

      billType = this.getBillingType(selectedPatient)
      if (billType === "Free")
        this.setState({ billType: billType, services: [], billCategory: {}, billSubCategory: {}, billSubCategoryOptions: [] })
      if (billType === "Paid") {
        if (this.state?.formData?.econsultation) {
          // const onlineConsultationOld = defaultConsultationServices.find(option => option.name === "Online Consultation Followup");
          // if (onlineConsultationOld) {
          //   updatedServices = [{
          //     item: onlineConsultationOld.label,
          //     serviceId: onlineConsultationOld.value,
          //     price: onlineConsultationOld.price,
          //     quantity: 1,
          //     discount: 0
          //   }, ...updatedServices];
          //   changedBillCategory = billCategoryOptions?.find((ele) => ele?._id === onlineConsultationOld?.categoryId?._id)
          //   changedPurpose = onlineConsultationOld
          // }
          const searchStr = !this.state.formData.patientId ? "Online Consultation New" : "Online Consultation Followup";
          const onlineConsultation = billSubCategoryOptions.find(ele => ele?.systemDefault && ele?.name === searchStr)
          this.setState({ billSubCategory: onlineConsultation, billCategory: defaultCategory })
          this.addServiceToBill(onlineConsultation);
        }
        else {
          // const consultationOld = defaultConsultationServices.find(option => option.name === "Consultation Followup");
          // if (consultationOld) {
          //   updatedServices = [{
          //     item: consultationOld.label,
          //     serviceId: consultationOld.value,
          //     price: consultationOld.price,
          //     quantity: 1,
          //     discount: 0
          //   }, ...updatedServices];
          //   changedBillCategory = billCategoryOptions?.find((ele) => ele?._id === consultationOld?.categoryId?._id)
          //   changedPurpose = consultationOld
          // }
          const searchStr = !this.state.formData.patientId ? "Consultation New" : "Consultation Followup";
          const opdConsultation = billSubCategoryOptions.find(ele => ele?.systemDefault && ele?.name === searchStr)
          this.setState({ billCategory: defaultCategory, billSubCategory: opdConsultation, defaultConsultationServices: billSubCategoryOptions, billSubCategoryOptions: billSubCategoryOptions })
          this.addServiceToBill(opdConsultation);
        }
      }


    }
    // this.setState({ billType: billType })
  }

  handleBill = (selectedBill) => {
    this.setState({
      latestBill: selectedBill,
      services: selectedBill?.services,
      totalAmount: selectedBill?.totalAmount,
      totalDiscountAmount: selectedBill?.totalDiscountAmount,
      totalPaidAmount: selectedBill?.totalPaidAmount,
      totalRemainingAmount: selectedBill?.totalRemainingAmount
    })
  }

  fillDefaultConsultation = (billType = "Paid") => {
    if (billType === "Paid") {
      const billCategoryOptions = this.props?.billCategoryList?.data.map((ele) => {
        return {
          label: ele?.name, value: ele?._id, ...ele
        }
      })
      const defaultCategory = billCategoryOptions.find(ele => ele?.systemDefault)
      this.setState({ billCategoryOptions: billCategoryOptions, billCategory: defaultCategory })
      if (this.isPageLoad && defaultCategory) {
        const filteredSubcategories = this.props?.billSubCategoryList?.data?.filter((subCat) => subCat?.categoryId?._id === defaultCategory?._id)
        const billSubCategoryOptions = filteredSubcategories.map((ele) => {
          return {
            label: ele?.name, value: ele?._id, ...ele
          }
        })

        if (!this.state?.formData?.econsultation) {
          const searchStr = !this.state.formData.patientId ? "Consultation New" : "Consultation Followup";

          const opdConsultation = billSubCategoryOptions.find(ele => ele?.systemDefault && ele?.name === searchStr)
          this.setState({ billSubCategory: opdConsultation, defaultConsultationServices: billSubCategoryOptions, billSubCategoryOptions: billSubCategoryOptions })
          this.addServiceToBill(opdConsultation);
        }
        if (this.state?.formData?.econsultation) {
          const searchStr = !this.state.formData.patientId ? "Online Consultation New" : "Online Consultation Followup";
          const onlineConsultation = billSubCategoryOptions.find(ele => ele?.systemDefault && ele?.name === searchStr)
          this.setState({ billSubCategory: onlineConsultation, defaultConsultationServices: billSubCategoryOptions, billSubCategoryOptions: billSubCategoryOptions })
          this.addServiceToBill(onlineConsultation);
        }
      }
    }
  }

  handleFillOldPatientLatestBillDetails = (latestBill = null, allSubCategories = []) => {
    if (latestBill) {
      const keysToMerge = [
        'categoryId',
        'clinicId',
        'createdAt',
        'description',
        'systemDefault',
        'systemDefaultName',
        'isActive'
      ];

      const updatedSelectedSubCategories = latestBill?.services.map(selected => {
        const match = allSubCategories.find(item => item?._id === selected?._id);

        if (!match) return selected; // No match found, return original

        // Extract only the specified keys from the match
        const mergedFields = keysToMerge.reduce((acc, key) => {
          if (key in match) {
            acc[key] = match[key];
          }
          return acc;
        }, {});

        return { ...selected, ...mergedFields };
      });

      this.setState({
        services: updatedSelectedSubCategories,
        totalAmount: latestBill?.totalAmount,
        totalDiscountAmount: latestBill?.totalDiscountAmount,
        totalPaidAmount: latestBill?.totalPaidAmount,
        totalRemainingAmount: latestBill?.totalRemainingAmount,
        latestBill: latestBill,
        hasUserEditedPaidAmount: true,
        totalRefundAmount: latestBill?.refundAmount || 0
      })
    }
  }

  handleTotalPaidAmount = (value) => {
    const input = value;
    if (input === "") {
      this.setState({
        totalPaidAmount: "",
        hasUserEditedPaidAmount: true
      });
    } else {
      const value = parseFloat(input);
      if (!isNaN(value) && value >= 0) {
        this.setState({
          totalPaidAmount: value,
          hasUserEditedPaidAmount: true
        });
      }
    }
  }

  handleUpdateServicesOnConsultationChange = (updatedServices) => {
    this.setState({ services: updatedServices })
  }

  handleBillChange = (selectedBill) => {
    const { services, totalPaidAmount } = selectedBill
    //  this.setState({
    //   services:selectedBill?.services,
    //   totalPaidAmount:selectedBill?.totalPaidAmount
    //  })
    this.setState({
      services,
      totalPaidAmount
    })
  }

  clearBillDetails = () => {
    this.setState({ services: [], totalPaidAmount: 0 })
  }

  handlePaymentMode = (mode) => {
    this.setState({ paymentMode: mode })
  }


  handleResetState = () => {
    let formArr = [];
    let tempFormData = JSON.parse(JSON.stringify(this.state.formData))
    tempFormData["patientId"] = "";
    tempFormData["patientEditId"] = "";
    tempFormData["patientClinicId"] = "";
    tempFormData["title"] = "";
    tempFormData["first_name"] = "";
    tempFormData["last_name"] = "";
    tempFormData["gender"] = "";
    tempFormData["dob"] = "";
    tempFormData["age"] = "";
    tempFormData["email"] = "";
    tempFormData["height"] = "";
    tempFormData["weight"] = "";
    tempFormData["city"] = "";
    tempFormData["remark"] = "";
    tempFormData["dobd"] = "";
    tempFormData["phone"] = "";
    tempFormData["econsultation"] = false;
    tempFormData["appointmentId"] = "";
    tempFormData["toggleConsultation"] = false;
    this.setState({
      formData: tempFormData,
      patientClinicIdError: "",
      services: [],
      totalPaidAmount: 0,
      paymentMode: "cash",
      showProcessing: false,
      search_date: this.props.search_date,
      patientClinicIdError: "",
      phoneError: "",
      datepickeropen: false,
      isOpdConsultation: true,
      isOnlineConsultation: false,
      lengthWeight: false,
      lengthHeight: false,
      billType: "",
      billCategory: {},
      billCategoryOptions: [],
      billSubCategory: {},
      billSubCategoryOptions: [],
      services: [],
      totalAmount: 0,
      totalPaidAmount: 0,
      totalDiscountAmount: 0,
      totalRemainingAmount: 0,
      paymentMode: "Cash",
      patients: [],
      selectedPatient: null,
      showPreviewModal: false,
      patientPrintDetails: null,
      patientDetail: null,
      mode: "new",
      isCreateVisit: false,// this flag is used for creating visit in case of updating old patient from reg+bill modal
      defaultConsultationServices: [],
      totalPaidAmountError: "",
      serviceErrorMsg: null,
      hasUserEditedPaidAmount: false,
      latestBill: null,
      billSubCategoryList: [],
      billOptions: [],
      formArr,
      createdAt: this.props?.patientData ? this.props?.patientData?.createdAt : null,

    });
  }

  handleRedirect = () => {
    let url = "/";
    if (this.props.history?.location?.pathname === "/") url = "/dashboard";
    else if (this.props.history?.location?.pathname === "/dashboard") url = "/";
    if (this.props.history?.location?.pathname === "/patient-search" && this.isSaveExitClicked) url = "/";
    if (this.isSaveExitClicked) {
      this.handleResetState()
      this.props.history.push({ pathname: url, econsultation: isOnline });
      const msg = `Patient ${this.state.mode === "edit" ? "updated" : "registered"} and bill created successfully`
      this.props.onDismiss(msg);
    }
  }

  handleRemoveErrorMsgForAlreadyExist = (itm) => {
    let error = this.state.serviceErrorMsg
    if (error?.id === itm?._id)
      error = null
    return error
  }


  render() {
    validation = new Validator(this.state.formData, rules, mess);
    validation.passes();
    validation.fails();
    let title = this.state.formData.title;
    this.billingRef = React.createRef();

    return (
      (this.props.showRegBillView === true) ?
        <Row>
          <NotificationSystem ref="notificationSystem" style={style} />
          {/* <div className="actionProcess" style={{ display: this.state.showProcessing ? 'block' : 'none' }}>
                    <img src={loadingImg} alt="Loading" width="40px" />
                    <center>Logging In - Please Wait</center>
                </div> */}
          <Col md={12} >
            <Row >
              <Col sm={7}>
                {this.props.showSearchBar && this.props.parentComponent === "headerlinks" &&
                  <FormGroup controlId="patientSelect">
                    <Select
                      id="txtSearchPatient"
                      options={this.state.patients}
                      onInputChange={(inputValue) => {
                        this.patientSearch(inputValue);
                      }}
                      onChange={(selected) => {
                        if (selected === null) {
                          this.handleResetState()
                        } else {
                          this.handlePatientDetails(selected);
                        }
                      }}
                      placeholder="Search"
                      isClearable
                      isSearchable
                      value={this.state.selectedPatient}
                    />
                  </FormGroup>
                }
              </Col>
              <Col sm={5} style={{ display: "flex", gap: "5px", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  className="btn-fill btn-wd btn btn-primary"
                  onClick={(e) => this.setShowPreviewModal(true)}
                  disabled={!this.state.latestBill?.billNumber}
                >
                  Print
                </button>
                <button
                  type="button"
                  onClick={(e) => {
                    this.isSaveButtonClicked = true;
                    this.patientRegistration(e);
                  }}
                  className="btn-fill btn-wd btn btn-primary"
                  disabled={this.state.showProcessing} // Added isFormDisabled
                >
                  {this.state.showProcessing ? (
                    <>
                      <img
                        src={loadingImg}
                        alt="Loading"
                        style={{ width: "20px", marginRight: "8px", verticalAlign: "middle" }}
                      />
                      Loading...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
                <button
                  type="button"
                  onClick={(e) => {
                    this.isSaveExitClicked = true;
                    this.isSaveButtonClicked ? this.cleanUp() : this.patientRegistration(e);
                  }}
                  className="btn-fill btn-wd btn btn-primary"
                  disabled={this.state.showProcessing} // Added isFormDisabled
                >
                  Exit
                </button>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            {this.state.alert}
            <Form horizontal >
              {/*<Col sm={12} className="patienSearchBox">
                       <FormGroup>
                          <Col sm={2}>
                          </Col>
                          <Col sm={6}>
                          <FormControl type="text" placeholder="Patient Id" name="patientClinicId" id="patientClinicId" value={this.state.formData.patientClinicId} onChange={e => { this.handleChange(e); }} autoComplete="off"/>
                              <span className="errorMsg">
                              {this.state.patientClinicIdError}
                              {this.state.formArr.patientClinicId && validation.errors.first('patientClinicId')}</span>
                          </Col>
                          <Col sm={4} className="regist-b">
                              <button type="button" onClick={(e)=>{this.onPatientId(e)}} className="btn-fill btn-wd btn btn-info mTpv">Search</button>
                              <button type="button" onClick={(e)=>{this.onClear(e)}} className="btn-fill btn-wd btn btn-info mTpv">Clear</button>
                          </Col>

                      </FormGroup>
                  </Col>*/}

              <Col sm={12} md={4} className="cus-mb-0">
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={12}>
                    <strong> General Info </strong>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Title <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={8}>
                    <select
                      className="form-control"
                      name="title"
                      onChange={(event) => this.handleChange(event)}
                      value={title}
                    >
                      <option value="">Select title</option>
                      {titleOptions.map(function (item) {
                        return (
                          <option key={item.value} value={item.label}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                    <span className="errorMsg">
                      {this.state.titleError}
                      {this.state.formArr.title &&
                        validation.errors.first("title")}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    First Name <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="first_name"
                      id="first_name"
                      value={this.state.formData.first_name}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <small>
                      Note:-Do not write any title in the first name, please
                      select it from the title drop down.
                    </small>
                    <div className="errorMsg">
                      {this.state.first_nameError}
                      {this.state.formArr.first_name &&
                        validation.errors.first("first_name")}
                    </div>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    Last Name
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="last_name"
                      id="last_name"
                      className="unmandt-f"
                      value={this.state.formData.last_name}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <span className="errorMsg">
                      {this.state.last_nameError}
                      {this.state.formArr.last_name &&
                        validation.errors.first("last_name")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Gender <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={8}>
                    <select
                      className="form-control"
                      name="gender"
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      value={this.state.formData.gender}
                    >
                      <option value="">-- Select Gender --</option>
                      <option value="Female">Female</option>
                      <option value="Male">Male</option>
                      {/* <option value="Other" selected={this.state.formData.gender === 'Other' ? true : false}>Other</option> */}
                    </select>
                    <span className="errorMsg">
                      {this.state.genderError}
                      {this.state.formArr.gender &&
                        validation.errors.first("gender")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    DOB/Age <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={4} className="cus_datepicker m-0">
                    <DatePicker
                      selected={
                        this.state.formData.dobd ? this.state.formData.dobd : ""
                      }
                      placeholderText="dd/mm/yyyy"
                      className="form-control"
                      name="dob"
                      maxDate={new Date()}
                      onChange={this.handleDob}
                      //disabled = {this.state.dobDisable}
                      dateFormat="dd/MM/yyyy"
                      value={
                        this.state.formData.dobd &&
                          this.state.formData.is_dob === true
                          ? this.state.formData.dobd
                          : ""
                      }
                      isValidDate={this.validDate}
                      closeOnSelect={false}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      autoComplete="off"
                      customInput={
                        <MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" />
                      }
                    />

                    <span className="errorMsg">
                      {this.state.dobError}
                      {this.state.formArr.dob && validation.errors.first("dob")}
                    </span>
                  </Col>
                  <Col sm={12} md={4} className="m-0">
                    <FormControl
                      type="text"
                      name="age"
                      id="age"
                      disabled={this.state.ageDisable}
                      value={
                        this.state.formData.age >= 0 ? this.state.formData.age : ""
                      }
                      onChange={(e) => {
                        this.handleAge(e);
                      }}
                      autoComplete="off"
                      maxLength="3"
                    />
                    <span className="errorMsg">
                      {this.state.ageError}
                      {this.state.formArr.age && validation.errors.first("age")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    Phone{" "}
                    {localStorage.getItem("is_mobile_no_mandatory") === "yes" ? (
                      <span className="star">*</span>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      autoComplete="off"
                      name="phone"
                      id="phone"
                      className="unmandt-f"
                      maxLength={12}
                      value={this.state.formData.phone}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                    />
                    <span className="errorMsg">
                      {this.state.phoneError}
                      {this.state.formArr.phone &&
                        validation.errors.first("phone")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="">
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Height <span className="for-wt-cm">(cm)</span><span style={{ color: "blue" }}>*</span>
                    <br />
                    <small>optional</small>
                  </Col>
                  <Col sm={12} md={8} className="m-0">
                    <FormControl
                      type="text"
                      name="height"
                      id="height"
                      maxLength="4"
                      value={
                        this.state.formData.height == 0
                          ? ""
                          : this.state.formData.height
                      }
                      onChange={(e) => {
                        if (e.target.value.length < 4) {
                          this.handleChange(e, "height");
                          this.setState({ ...this.state, lengthHeight: false });
                        } else this.setState({ ...this.state, lengthHeight: true });
                      }}
                      autoComplete="off"
                    />
                    {this?.state?.lengthHeight && (
                      <div style={{ color: "red" }}>
                        <p style={{ fontSize: "13px" }}>
                          Maximum 3 Character Allowed
                        </p>
                      </div>
                    )}
                    <span className="errorMsg">
                      {this.state.heightError}
                      {this.state.formArr.height &&
                        validation.errors.first("height")}
                    </span>
                  </Col>
                </FormGroup>


                <FormGroup className="">
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Weight <span className="for-wt-cm">(kg)</span><span style={{ color: "blue" }}>*</span>
                    <br />
                    <small>optional</small>
                  </Col>
                  <Col sm={12} md={8} className="m-0">
                    <FormControl
                      type="text"
                      name="weight"
                      id="weight"
                      maxLength="6"
                      value={
                        this.state.formData.weight == 0
                          ? ""
                          : this.state.formData.weight
                      }
                      onChange={(e) => {
                        if (e.target.value.length < 6) {
                          this.handleChange(e, "weight");
                          this.setState({ ...this.state, lengthWeight: false });
                        } else this.setState({ ...this.state, lengthWeight: true });
                      }}
                      autoComplete="off"
                    />
                    {this?.state?.lengthWeight && (
                      <div style={{ color: "red" }}>
                        <p style={{ fontSize: "13px" }}>
                          Maximum 5 Character Allowed
                        </p>
                      </div>
                    )}
                    <span className="errorMsg">
                      {this.state.weightError}
                      {this.state.formArr.weight &&
                        validation.errors.first("weight")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    City
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="city"
                      id="city"
                      className="unmandt-f"
                      value={this.state.formData.city}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <span className="errorMsg">
                      {this.state.cityError}
                      {this.state.formArr.city && validation.errors.first("city")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    Remark
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      rows="3"
                      componentClass="textarea"
                      name="remark"
                      bsClass="form-control unmandt-f"
                      value={this.state.formData.remark}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <span className="errorMsg">
                      {this.state.remarkError}
                      {this.state.formArr.remark &&
                        validation.errors.first("remark")}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={12} md={4} className="font-weight-normal cus-mb-0">Consultation</Col>
                  <Col sm={12} md={8} className="e-consultation">
                    <Col componentClass={ControlLabel} className="um-mandentory">
                      <form className="consultation-radio">
                        <input
                          name="econsultation"
                          type="radio"
                          id="OPD-Consultation"
                          value={false}
                          onClick={(e) => {
                            if (!this.state.isConsultationDisabled) {
                              this.setState({
                                isOpdConsultation: true,
                                isOnlineConsultation: false,
                              });
                              this.handleChange(e);
                            }
                          }}
                          checked={this.state.isOpdConsultation === true}
                          disabled={this.state.isConsultationDisabled}
                        />
                        <label htmlFor="OPD-Consultation" className="cus-mr-2">OPD</label>
                        <input
                          name="econsultation"
                          type="radio"
                          id="online-consultation"
                          value={true}
                          onClick={(e) => {
                            if (!this.state.isConsultationDisabled) {
                              this.setState({
                                isOnlineConsultation: true,
                                isOpdConsultation: false,
                              });
                              this.handleChange(e);
                            }
                          }}
                          checked={this.state.isOnlineConsultation === true}
                          disabled={this.state.isConsultationDisabled}
                        />
                        <label htmlFor="online-consultation">
                          Online
                        </label>
                      </form>
                    </Col>
                  </Col>
                  {this.state.isConsultationDisabled ? (
                    <span className="errorMsg" style={{ color: 'red' }}>
                      Consultation type cannot be changed on already created bill
                    </span>
                  ) : (
                    <span className="errorMsg">
                      {this.state.econsultationError}
                      {this.state.formArr.econsultation &&
                        validation.errors.first("econsultation")}
                    </span>
                  )}
                </FormGroup>
              </Col>
              <Col sm={12} md={3} className="cus-mb-0">
                {localStorage.getItem("isEmailFacility") === "yes" ? (
                  <FormGroup>
                    <Col
                      componentClass={ControlLabel}
                      sm={12}
                      md={4}
                      className="um-mandentory"
                    >
                      Email
                    </Col>
                    <Col sm={12} md={8}>
                      <FormControl
                        type="email"
                        name="email"
                        id="email"
                        className="unmandt-f"
                        value={this.state.formData.email}
                        onChange={(e) => {
                          this.handleChange(e);
                        }}
                        autoComplete="off"
                      />
                      <span className="errorMsg">
                        {this.state.emailError}
                        {this.state.formArr.email &&
                          validation.errors.first("email")}
                      </span>
                    </Col>
                  </FormGroup>
                ) : (
                  ""
                )}
                <BillingInfo
                  allProps={this.props}
                  allState={this.state}
                  addServiceToBill={this.addServiceToBill}
                  handleFillOldPatientLatestBillDetails={this.handleFillOldPatientLatestBillDetails}
                  totalPaidAmount={this.state?.totalPaidAmount}
                  handleTotalPaidAmount={this.handleTotalPaidAmount}
                  handleUpdateServicesOnConsultationChange={this.handleUpdateServicesOnConsultationChange}
                  handleBillChange={this.handleBillChange}
                  clearBillDetails={this.clearBillDetails}
                  handlePaymentMode={this.handlePaymentMode}
                  onBillingDisabledChange={this.handleBillingDisabledChange}
                  parentComponent={this.props.parentComponent ?? ""}
                  isBillingDisabled={this.state.isBillingDisabled}
                />
                {/* <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={12}>
                    <strong> Billing Info </strong>
                  </Col>
                </FormGroup>
                {this.state.billOptions.length > 0 &&
                  <FormGroup>
                    <Col componentClass={ControlLabel} sm={12} md={5}>
                      Bills
                    </Col>
                    <Col sm={12} md={7}>
                      <Select
                        options={this.state.billOptions}
                        value={this.state.latestBill}
                        onChange={(selected) => {
                          this.handleBill(selected)
                        }}
                        isClearable
                        isSearchable
                      />
                    </Col>
                  </FormGroup>
                }
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={5}>
                    Bill Type
                  </Col>
                  <Col sm={12} md={7}>
                    <select
                      className="form-control"
                      name="billType"
                      onChange={(event) => this.handleChange(event)}
                      value={this.state.billType || ""}
                    >
                      <option value="">Select Bill Type</option>
                      {billTypeOptions.map(function (item) {
                        return (
                          <option key={item.value} value={item.label}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>

                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={5}>
                    Bill Category
                  </Col>
                  <Col sm={12} md={7}>
                    <Select
                      options={this.state.billCategoryOptions}
                      value={this.state.billCategory}
                      onChange={(selected) => {
                        this.handleBillCategory(selected)
                      }}
                      isClearable
                      isSearchable
                    />
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={5}>
                    Purpose
                  </Col>
                  <Col sm={12} md={7}>
                    <Select
                      options={this.state.billSubCategoryOptions}
                      value={this.state.billSubCategory}
                      onChange={(selected) => {
                        this.setState({ billSubCategory: selected });
                        this.addServiceToBill(selected);
                      }}
                      isClearable
                      isSearchable
                    />
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={5} style={{ height: "30px" }}>
                    Payment Mode
                  </Col>
                  <Col sm={12} md={7}>
                    <select
                      className="form-control"
                      name="paymentMode"
                      onChange={(e) => this.setState({ paymentMode: e.target.value })}
                      value={this.state.paymentMode || ""}
                    >
                      <option value="">Select Payment Mode</option>
                      <option value="Cash">Cash</option>
                      <option value="Card">Card</option>
                      <option value="UPI">UPI</option>
                    </select>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={5}>
                    Amount Paid
                  </Col>
                  <Col sm={12} md={7}>
                    <FormControl
                      type="number"
                      name="totalPaidAmount"
                      id="totalPaidAmount"
                      value={this.state.totalPaidAmount || ""}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (input === "") {
                          this.setState({
                            totalPaidAmount: "",
                            hasUserEditedPaidAmount: true
                          });
                        } else {
                          const value = parseFloat(input);
                          if (!isNaN(value) && value >= 0) {
                            this.setState({
                              totalPaidAmount: value,
                              hasUserEditedPaidAmount: true
                            });
                          }
                        }
                      }}

                      onKeyDown={(e) => {
                        // Prevent entering negative values with the down arrow key
                        if (e.key === 'ArrowDown' && this.state.totalPaidAmount <= 0) {
                          e.preventDefault();  // Prevent decreasing the value below 0
                        }
                      }}
                      min="0" // Ensure the value can't go below 0
                      autoComplete="off"
                    />
                    {this.state.totalPaidAmountError && (
                      <div className="errorMsg" style={{ color: "red" }}>
                        {this.state.totalPaidAmountError}
                      </div>
                    )}
                  </Col>
                </FormGroup> */}

              </Col>
              <Col sm={12} md={5} className="cus-mb-0 remove-cell-pd">
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={12}>
                    <strong className="cus-pl-1"> Billing Total </strong>
                  </Col>
                </FormGroup>

                <div className="mt-4" >
                  <BillingTable
                    items={this.state.services}
                    isDisabled={this.state.isBillingDisabled}
                    totalAmount={this.state.totalAmount}
                    totalPaidAmount={this.state.totalPaidAmount}
                    totalDiscountAmount={this.state.totalDiscountAmount}
                    totalRemainingAmount={this.state.totalRemainingAmount}
                    handleTotalAmount={(value) => {
                      if (!this.state.hasUserEditedPaidAmount) {
                        this.setState({
                          totalAmount: value,
                          totalPaidAmount: value
                        });
                      } else {
                        this.setState({ totalAmount: value });
                      }
                    }}
                    handleTotalDiscount={(calculatedDiscount, finalTotal) => {
                      console.log(calculatedDiscount, finalTotal, this.state.hasUserEditedPaidAmount, "*********")
                      if (!this.state.hasUserEditedPaidAmount) {
                        this.setState({
                          totalDiscountAmount: calculatedDiscount,
                          totalPaidAmount: finalTotal
                        });
                      } else {
                        this.setState({
                          totalPaidAmount: this.state.totalPaidAmount,
                          totalDiscountAmount: calculatedDiscount,
                        })
                      }
                    }}
                    handleTotalRemaining={(value) => this.setState({ totalRemainingAmount: value })}
                    onItemChange={(id, field, value) => {
                      const services = this.state.services.map(item =>
                        item.id === id ? { ...item, [field]: value === "" ? "" : parseFloat(value) } : item
                      );
                      this.setState({ services });
                    }}
                    onItemDelete={(id, itm) => {
                      const services = this.state.services.filter(item => item.id !== id);
                      let serviceErrorMsg = this.state.serviceErrorMsg
                      if (serviceErrorMsg)
                        serviceErrorMsg = this.handleRemoveErrorMsgForAlreadyExist(itm)
                      this.setState({ services, serviceErrorMsg });
                    }}
                    serviceErrorMsg={this?.state?.serviceErrorMsg?.msg || ""}
                    totalRefundAmount={this?.state?.totalRefundAmount}
                  />
                </div>
              </Col>
            </Form>
          </Col>
          <Modal show={this.state.showPreviewModal} onHide={() => this.setShowPreviewModal(false)} dialogClassName="modal-lg">
            <Modal.Body>
              <Print
                patient={this.state.patientDetail}
                services={this.state.services}
                totalAmount={this.state.totalAmount}
                totalDiscountAmount={this.state.totalDiscountAmount}
                totalPaidAmount={this.state.totalPaidAmount}
                totalRemainingAmount={this.state.totalRemainingAmount}
                setShowPreviewModal={this.setShowPreviewModal}
                billNumber={this.state?.latestBill?.billNumber}
              />
            </Modal.Body>
          </Modal>
        </Row> :
        <Row>
          <NotificationSystem ref="notificationSystem" style={style} />
          {/* <div className="actionProcess" style={{ display: this.state.showProcessing ? 'block' : 'none' }}>
                          <img src={loadingImg} alt="Loading" width="40px" />
                          <center>Logging In - Please Wait</center>
                      </div> */}
          <Col md={12}>
            {this.state.alert}
            <Form horizontal>
              {/*<Col sm={12} className="patienSearchBox">
                             <FormGroup>
                                <Col sm={2}>
                                </Col>
                                <Col sm={6}>
                                <FormControl type="text" placeholder="Patient Id" name="patientClinicId" id="patientClinicId" value={this.state.formData.patientClinicId} onChange={e => { this.handleChange(e); }} autoComplete="off"/>
                                    <span className="errorMsg">
                                    {this.state.patientClinicIdError}
                                    {this.state.formArr.patientClinicId && validation.errors.first('patientClinicId')}</span>
                                </Col>
                                <Col sm={4} className="regist-b">
                                    <button type="button" onClick={(e)=>{this.onPatientId(e)}} className="btn-fill btn-wd btn btn-info mTpv">Search</button>
                                    <button type="button" onClick={(e)=>{this.onClear(e)}} className="btn-fill btn-wd btn btn-info mTpv">Clear</button>
                                </Col>
      
                            </FormGroup>
                        </Col>*/}

              <Col sm={12} md={6}>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Title <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={8}>
                    <select
                      className="form-control"
                      name="title"
                      onChange={(event) => this.handleChange(event)}
                      value={title}
                    >
                      <option value="">Select title</option>
                      {titleOptions.map(function (item) {
                        return (
                          <option key={item.value} value={item.label}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                    <span className="errorMsg">
                      {this.state.titleError}
                      {this.state.formArr.title &&
                        validation.errors.first("title")}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    First Name <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="first_name"
                      id="first_name"
                      value={this.state.formData.first_name}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <small>
                      Note:-Do not write any title in the first name, please
                      select it from the title drop down.
                    </small>
                    <div className="errorMsg">
                      {this.state.first_nameError}
                      {this.state.formArr.first_name &&
                        validation.errors.first("first_name")}
                    </div>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    Last Name
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="last_name"
                      id="last_name"
                      className="unmandt-f"
                      value={this.state.formData.last_name}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <span className="errorMsg">
                      {this.state.last_nameError}
                      {this.state.formArr.last_name &&
                        validation.errors.first("last_name")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Gender <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={8}>
                    <select
                      className="form-control"
                      name="gender"
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      value={this.state.formData.gender}
                    >
                      <option value="">-- Select Gender --</option>
                      <option value="Female">Female</option>
                      <option value="Male">Male</option>
                      {/* <option value="Other" selected={this.state.formData.gender === 'Other' ? true : false}>Other</option> */}
                    </select>
                    <span className="errorMsg">
                      {this.state.genderError}
                      {this.state.formArr.gender &&
                        validation.errors.first("gender")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    DOB/Age <span className="star">*</span>
                  </Col>
                  <Col sm={12} md={4} className="cus_datepicker">
                    <DatePicker
                      selected={
                        this.state.formData.dobd ? this.state.formData.dobd : ""
                      }
                      placeholderText="dd/mm/yyyy"
                      className="form-control"
                      name="dob"
                      maxDate={new Date()}
                      onChange={this.handleDob}
                      //disabled = {this.state.dobDisable}
                      dateFormat="dd/MM/yyyy"
                      value={
                        this.state.formData.dobd &&
                          this.state.formData.is_dob === true
                          ? this.state.formData.dobd
                          : ""
                      }
                      isValidDate={this.validDate}
                      closeOnSelect={false}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      autoComplete="off"
                      customInput={
                        <MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" />
                      }
                    />

                    <span className="errorMsg">
                      {this.state.dobError}
                      {this.state.formArr.dob && validation.errors.first("dob")}
                    </span>
                  </Col>
                  <Col sm={12} md={4}>
                    <FormControl
                      type="text"
                      name="age"
                      id="age"
                      disabled={this.state.ageDisable}
                      value={
                        this.state.formData.age >= 0 ? this.state.formData.age : ""
                      }
                      onChange={(e) => {
                        this.handleAge(e);
                      }}
                      autoComplete="off"
                      maxLength="3"
                    />
                    <span className="errorMsg">
                      {this.state.ageError}
                      {this.state.formArr.age && validation.errors.first("age")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    Phone{" "}
                    {localStorage.getItem("is_mobile_no_mandatory") === "yes" ? (
                      <span className="star">*</span>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      autoComplete="off"
                      name="phone"
                      id="phone"
                      className="unmandt-f"
                      maxLength={12}
                      value={this.state.formData.phone}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                    />
                    <span className="errorMsg">
                      {this.state.phoneError}
                      {this.state.formArr.phone &&
                        validation.errors.first("phone")}
                    </span>
                  </Col>
                </FormGroup>
              </Col>
              <Col sm={12} md={6}>
                {localStorage.getItem("isEmailFacility") === "yes" ? (
                  <FormGroup>
                    <Col
                      componentClass={ControlLabel}
                      sm={12}
                      md={4}
                      className="um-mandentory"
                    >
                      Email
                    </Col>
                    <Col sm={12} md={8}>
                      <FormControl
                        type="email"
                        name="email"
                        id="email"
                        className="unmandt-f"
                        value={this.state.formData.email}
                        onChange={(e) => {
                          this.handleChange(e);
                        }}
                        autoComplete="off"
                      />
                      <span className="errorMsg">
                        {this.state.emailError}
                        {this.state.formArr.email &&
                          validation.errors.first("email")}
                      </span>
                    </Col>
                  </FormGroup>
                ) : (
                  ""
                )}

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Height(CM)<span style={{ color: "blue" }}>*</span>
                    <br />
                    <small>optional</small>
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="height"
                      id="height"
                      maxLength="4"
                      value={
                        this.state.formData.height == 0
                          ? ""
                          : this.state.formData.height
                      }
                      onChange={(e) => {
                        if (e.target.value.length < 4) {
                          this.handleChange(e, "height");
                          this.setState({ ...this.state, lengthHeight: false });
                        } else this.setState({ ...this.state, lengthHeight: true });
                      }}
                      autoComplete="off"
                    />
                    {this?.state?.lengthHeight && (
                      <div style={{ color: "red" }}>
                        <p style={{ fontSize: "13px" }}>
                          Maximum 3 Character Allowed
                        </p>
                      </div>
                    )}
                    <span className="errorMsg">
                      {this.state.heightError}
                      {this.state.formArr.height &&
                        validation.errors.first("height")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col componentClass={ControlLabel} sm={12} md={4}>
                    Weight(KG)<span style={{ color: "blue" }}>*</span>
                    <br />
                    <small>optional</small>
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="weight"
                      id="weight"
                      maxLength="6"
                      value={
                        this.state.formData.weight == 0
                          ? ""
                          : this.state.formData.weight
                      }
                      onChange={(e) => {
                        if (e.target.value.length < 6) {
                          this.handleChange(e, "weight");
                          this.setState({ ...this.state, lengthWeight: false });
                        } else this.setState({ ...this.state, lengthWeight: true });
                      }}
                      autoComplete="off"
                    />
                    {this?.state?.lengthWeight && (
                      <div style={{ color: "red" }}>
                        <p style={{ fontSize: "13px" }}>
                          Maximum 5 Character Allowed
                        </p>
                      </div>
                    )}
                    <span className="errorMsg">
                      {this.state.weightError}
                      {this.state.formArr.weight &&
                        validation.errors.first("weight")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    City
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      type="text"
                      name="city"
                      id="city"
                      className="unmandt-f"
                      value={this.state.formData.city}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <span className="errorMsg">
                      {this.state.cityError}
                      {this.state.formArr.city && validation.errors.first("city")}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col
                    componentClass={ControlLabel}
                    sm={12}
                    md={4}
                    className="um-mandentory"
                  >
                    Remark
                  </Col>
                  <Col sm={12} md={8}>
                    <FormControl
                      rows="4"
                      componentClass="textarea"
                      name="remark"
                      bsClass="form-control unmandt-f"
                      value={this.state.formData.remark}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      autoComplete="off"
                    />
                    <span className="errorMsg">
                      {this.state.remarkError}
                      {this.state.formArr.remark &&
                        validation.errors.first("remark")}
                    </span>
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={12} md={4}></Col>
                  <Col sm={12} md={8} className="e-consultation">
                    <Col componentClass={ControlLabel} className="um-mandentory">
                      <form className="consultation-radio">
                        <input
                          name="econsultation"
                          type="radio"
                          id="OPD-Consultation"
                          value={false}
                          onClick={(e) => {
                            this.setState({
                              isOpdConsultation: true,
                              isOnlineConsultation: false,
                            });
                            this.handleChange(e);
                          }}
                          checked={
                            this.state.isOpdConsultation === true ? "true" : ""
                          }
                        />
                        <label for="OPD-Consultation">OPD Consultation</label>
                        <br />
                        <input
                          name="econsultation"
                          type="radio"
                          id="online-consultation"
                          value={true}
                          onClick={(e) => {
                            this.setState({
                              isOnlineConsultation: true,
                              isOpdConsultation: false,
                            });
                            this.handleChange(e);
                          }}
                          checked={
                            this.state.isOnlineConsultation === true ? "true" : ""
                          }
                        />
                        <label for="online-consultation">
                          Online Consultation
                        </label>
                      </form>
                    </Col>
                  </Col>
                  <span className="errorMsg">
                    {this.state.econsultationError}
                    {this.state.formArr.econsultation &&
                      validation.errors.first("econsultation")}
                  </span>
                </FormGroup>
              </Col>

              <Col mdOffset={2} sm={12} md={6}>
                <button
                  type="button"
                  onClick={(e) => this.patientRegistration(e)}
                  className="btn-fill btn-wd btn btn-primary"
                  disabled={this.state.showProcessing}
                >
                  Save
                </button>
              </Col>
            </Form>
          </Col>
        </Row>
    );
  }
}

function mapStateToProps(state) {
  return {
    PatientRegistrationMessage: state.home.PatientRegistration,
    isPatientRegistration: state.home.isPatientRegistration,
    isPatientRegistrationError: state.home.isPatientRegistrationError,

    PatientEditMessage: state.home.PatientEdit,
    isPatientEdit: state.home.isPatientEdit,
    isPatientEditError: state.home.isPatientEditError,

    PatientDetail: state.home.PatientDetail,
    isPatientDetail: state.home.isPatientDetail,
    isPatientDetailError: state.home.isPatientDetailError,

    VisitList: state.home.VisitList,
    isVisitList: state.home.isVisitList,
    isVisitListError: state.home.isVisitListError,

    addVisit: state.patient.addVisit,
    isAddVisit: state.patient.isAddVisit,
    isAddVisitError: state.patient.isAddVisitError,

    taskScreen: state.taskScreen,
    isHeightWeightValidation: state.isHeightWeightValidation,
    vitalSignsData: state.emr.vitalSignsData,

    isBillCategoryList: state.billing.isBillCategoryList,
    billCategoryList: state.billing.billCategoryList,
    isBillCategoryListError: state.billing.isBillCategoryListError,

    isBillSubCategoryList: state.billing.isBillSubCategoryList,
    billSubCategoryList: state.billing.billSubCategoryList,
    isBillSubCategoryListError: state.billing.isBillSubCategoryListError,

    isBillCreated: state.billing.isBillCreated,
    isBillCreatedError: state.billing.isBillCreatedError,
    billCreated: state.billing.billCreated,

    isBillUpdated: state.billing.isBillUpdated,
    isBillUpdatedError: state.billing.isBillUpdatedError,
    billUpdated: state.billing.billUpdated,

    isBillList: state.billing.isBillList,
    isBillListError: state.billing.isBillListError,
    billList: state.billing.billList


  };
}
export default withRouter(
  connect(mapStateToProps, {
    patientRegistrationAction,
    patientEditAction,
    patientListAction,
    getPatientDetailAction,
    visitListAction,
    addVisitAction,
    taskScreenAction,
    emrSetVitalSignsAction,
    taskScreenHeightWeightRequireForCaloryAction,
    billCategoryListAction,
    billSubCategoryListAction,
    createBillAction,
    updateBillAction,
    billListAction
  })(PatientRegistration)
);
